import React from "react";
import ResidenceCard from "./ResidenceCard";

export default function Residence(props) {
	const { residence } = props;
	return <ResidenceCard residence={residence} to={`${residence.slug}`} />;
}
